import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { LineSeperator, RowContainer, TlyfeButtonWrapper } from '../style';
import OpenFlowModal from '../../atoms/modal';
import { Button } from '../../atoms/button';
import TenantModal from './TenantModal';
import Feather from '@expo/vector-icons/Feather';
import InfowaningBox from './infowaningBox';
import EditTenantModal from './TenantModalEdit';
const tenants = [
    { name: "Miss. SHOBHITAS ASDSD", id: "PAMU6BWUT", email: "robby1234@yopmail.com", postcode: "PL23 1AB", contact: "09759175743", isLead: false },
    { name: "Mr. HITESH GUNWANT", id: "BXYMEM8TM", email: "gunwant.hitesh100@gmail.com", postcode: "263139", contact: "233434343434", isLead: true }
];



const TenantListScreen = (props) => {
    const {addedUsers,flowId}=props
    const [showMakeHeadModal, setShowMakeHeadModal] = React.useState(false);
    const [showDeleteCardModal, setShowDeleteCardModal] = React.useState(false);
    const [CurrIndex, setCrIndex] = React.useState(null);
    const [showModal, SetshowModal] = React.useState(false);
    const [showEditModal, setshowEditModal] = React.useState(false);

    
    

    const renderRemoveCardBody = () => (
        <View
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <Text>Do you wish to remove this?</Text>
          <TlyfeButtonWrapper style={{marginBottom: '5%'}}>
            <Button
              onClick={() => {
                props.onDelete(CurrIndex);
                setShowDeleteCardModal(false);
              }}
              title={'Yes'}
              type="stripe"
              style={{ borderColor: '#90C418', color: '#90C418' }}
            />
            &nbsp;&nbsp;
            <Button
              onClick={() => {
                setShowDeleteCardModal(false);
              }}
              style={{ borderColor: '#FC4850', color: '#FC4850' }}
              title={'No'}
              type="stripe"
            />
          </TlyfeButtonWrapper>
    
          <RowContainer>
            <Text>Please Note</Text>
            <Text> Once you remove this you cannot undo this change</Text>
          </RowContainer>
        </View>
      );
      const renderMakeLeadModalBody = () => (
        <View
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <Text>
            Do you wish to make this tenant as Lead?
          </Text>
          <TlyfeButtonWrapper style={{marginTop:20}}>
            <Button
              onClick={() => {
                props.onMakeLead(CurrIndex);
                setShowMakeHeadModal(false);
                // setConfirm(true)
              }}
              style={{ borderColor: '#90C418', color: '#90C418' }}
              title={'Yes'}
              type="stripe"
            />
            &nbsp;&nbsp;
            <Button
              onClick={() => {
                setShowMakeHeadModal(false);
              }}
              style={{ borderColor: '#FC4850', color: '#FC4850' }}
              title={'No'}
              type="stripe"
            />
          </TlyfeButtonWrapper>
        </View>
      );
    const TenantCard = (item) => {
        console.log("item",item)
        const data ={
            opbrix_id: item?.app_user?.opbrix_id,
            title: item?.app_user?.user?.title,
            first_name: item?.app_user?.user?.first_name,
            last_name: item?.app_user?.user?.last_name,
            email: item?.app_user?.user?.email,
            number: item?.app_user?.user?.contact_number,
            post_code: item?.app_user?.user?.postcode,
            address: item?.app_user?.user?.address,
            tenant_id: item?.app_user?.opbrix_id,
            isLead:item?.is_lead,
            index:item.index
          }
    
        return (
            <View style={styles.card}>
                <View style={[styles.circle,{backgroundColor:data?.isLead ? "rgba(23, 215, 106, 0.12)":"rgba(160, 112, 196, 0.12)"}]}><Text style={[styles.initials,{color:data?.isLead?"rgb(23, 215, 106)":"rgb(160, 112, 196)"}]}>{ data?.first_name?.length? data?.first_name[0]:""}</Text></View>
                <View style={styles.cardContent}>
                    <View style={{ flexDirection: 'row', justifyContent: "space-between",marginBottom:10 }}>
                        <View style={{ flex: 0.4 }}>
                            <Text style={styles.name}>{(data?.first_name||"") + " "+(data?.last_name||"") }</Text>
                        </View>
                        <View style={{ flex: 0.6,flexDirection:'row',justifyContent:'flex-end',alignItems:"center",marginLeft:4 }}>
                            {!data?.isLead && <TouchableOpacity 
                              onPress={() => {
                                setCrIndex(item.index)
                                setShowMakeHeadModal(true);
                              }}
                            style={styles.leadBadge}><Text style={styles.leadText}>MAKE LEAD</Text></TouchableOpacity>}
                           <TouchableOpacity
                            onPress={() => {
                                setCrIndex(item.index)
                                setShowDeleteCardModal(true);
                              }}
                           >
                            <MaterialIcons name="delete" size={24} color="red" />
                            </TouchableOpacity>
                            <TouchableOpacity
                             onPress={() => {
                              setCrIndex(item.index)
                              setshowEditModal(true);
                            }}
                           >
                           
                            <MaterialIcons name="edit" size={24} color="rgb(9, 178, 194)" />
                            </TouchableOpacity>
                        </View>

                    </View>
                    <Text style={styles.info}>TLYFE ID: {data?.opbrix_id}</Text>
                    <Text style={styles.info}>Email: {data?.email}</Text>
                    <Text style={styles.info}>Postcode: {data?.post_code}</Text>
                    <Text style={styles.info}>Contact: {data?.number}</Text>
                </View>
    
            </View>
        );
    };
    return (
        <View style={styles.container}>
            <Text style={styles.heading}>Your applicant tenants</Text>
            <Text style={styles.subHeading}>

                Begin the tenant onboarding process by "pairing" your Applicant Tenant(s) to your property.</Text>
            <Text style={styles.subHeading}>
            tlyfePro with tlyfe and it is recommended that you request that the Applicant Tenant(s) registers with tlyfe before you start this process in order to maximise process efficiency.
            </Text>
          
                <InfowaningBox
                text={"Ask the applicants to check if all the details are entered correctly via the tlyfe app. They are automatically sent a registration email if you include their email address in the tenant section."}
                />
       <InfowaningBox
                text={"PLEASE NOTE: If you incorrectly enter the tenants email, it is not possible to edit this due to security reasons. You must delete the tenant and enter the correct email. If you wish to change a tenants email, please contact info@hubita.co.uk."}
              red
              />
            <TouchableOpacity 
            onPress={()=>{
                SetshowModal(true)
            }}
            style={styles.addButton}><Text style={styles.addButtonText}>+ ADD TENANT</Text></TouchableOpacity>

            <View style={{ flexDirection: "row", justifyContent: "flex-start",flexWrap:"wrap" }}>
                {addedUsers.map((tenant, index) => (
                    <TenantCard key={index} {...tenant} index={index} />
                ))}

            </View>
             
            {showDeleteCardModal && (
        <OpenFlowModal
          showModal={showDeleteCardModal}
          setShowModal={setShowDeleteCardModal}
          modalBody={renderRemoveCardBody()}
          showFooter={false}
          modalHeading={"Remove ?"}
          modalWidth={600}
        />
      )}
       {showMakeHeadModal && (
        <OpenFlowModal
          showModal={showMakeHeadModal}
          setShowModal={setShowMakeHeadModal}
          modalBody={renderMakeLeadModalBody()}
          showFooter={false}
          modalHeading="Make Lead ?"
          modalWidth={600}
        />
      )}
      {showModal&&<TenantModal
      flowId={flowId}
       showModal={showModal}
       addedUsers={addedUsers}
       onClose={() => {
        SetshowModal(false)
       }}
       onSubmit={() => {
           deleteCertificate()
       }}
      />}
   
       {showEditModal&&
       <EditTenantModal
      flowId={flowId}
       showModal={showEditModal}
       addedUsers={addedUsers}
       onClose={() => {
        setshowEditModal(false)
       }}
       CurrIndex={CurrIndex}
      />}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        padding: 16,
        backgroundColor: 'white',
        borderRadius: 12,
        elevation: 2,
        marginTop:30
     },
    heading: { fontSize: 20, fontWeight: 'bold', color: '#6a4bb3', marginBottom: 10 },
    subHeading: { fontSize: 14, color: '#666', marginBottom: 10 },
    infoBox: { padding: 10, backgroundColor: '#e0f4ff', borderRadius: 8, marginBottom: 10 ,flexDirection:"row",},
    warningBox: { padding: 10, backgroundColor: '#ffe6e6', borderRadius: 8, marginBottom: 20 },
    card: {
        backgroundColor: 'white', padding: 16, borderRadius: 10, flexDirection: 'row', alignItems: 'center', marginBottom: 10,
         shadowColor: '#000', shadowOpacity: 0.1, shadowRadius: 5, elevation: 3,
        maxWidth: 340,
        marginRight: 10,
        marginBottom: 10,
        width:"100%"
    },
    circle: { width: 40, height: 40, borderRadius: 20, backgroundColor: '#d3c4f4', alignItems: 'center', justifyContent: 'center', marginRight: 10 },
    initials: { fontSize: 18, fontWeight: 'bold', color: 'balck' },
    cardContent: { flex: 1 },
    name: { fontSize: 16, fontWeight: 'bold' },
    info: { fontSize: 12, color: '#555' },
    leadBadge: { backgroundColor: 'rgb(160, 112, 196)', paddingHorizontal: 8, paddingVertical: 4, borderRadius: 5 },
    leadText: { color: 'white', fontSize: 10, fontWeight: 'bold' },
    editButton: { right: 40 },
    editText: { fontSize: 18, color: 'rgb(160, 112, 196)' },
    deleteButton: { right: 10 },
    deleteText: { fontSize: 18, color: 'red' },
    addButton: { backgroundColor: '#e91e63', padding: 10, borderRadius: 8, alignItems: 'center', marginVertical: 20,alignSelf:'flex-end' },
    addButtonText: { color: 'white', fontSize: 14, fontWeight: 'bold' },
    sendButton: { backgroundColor: '#rgb(9, 178, 194)', padding: 10, borderRadius: 8, alignItems: 'center',width:150,alignSelf:'flex-end'},
    sendButtonText: { color: 'white', fontSize: 14, fontWeight: 'bold' }
});

export default TenantListScreen;
